import { Component, ContentChild, Input } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: "app-driveb-detail-view",
    templateUrl: "./detail-view.component.html",
    styleUrls: ["./detail-view.component.scss"],
    standalone: false
})
export class DetailViewComponent {
  @Input() public isPadded = true;

  @ContentChild(RouterOutlet)
  private _routerOutlet!: RouterOutlet;

  public get hasRouterOutlet(): boolean {
    return !!this._routerOutlet;
  }
}
